import {
    StrongoShipmentParcel,
    type StrongoShipmentParcelData
} from "@/types/shipments/Strongo/StrongoShipmentParcel.ts";

export class StrongoShipmentParcelDeliveryDateChange {
    public id: number;
    public previous_delivery_date: Date | null;
    public new_delivery_date: Date | null;
    public created_at: Date | null;
    public strongoShipmentParcel: StrongoShipmentParcel | null;

    constructor(data: StrongoShipmentParcelDeliveryDateChangeData | void) {
        if (data === undefined) {
            this.id = 0;
            this.previous_delivery_date = null;
            this.new_delivery_date = null;
            this.created_at = null;
            this.strongoShipmentParcel = null;
        } else {
            this.id = data.id;
            this.previous_delivery_date = null;
            if (data.previous_delivery_date !== undefined && data.previous_delivery_date !== null) {
                this.previous_delivery_date = new Date(data.previous_delivery_date);
            }
            this.new_delivery_date = null;
            if (data.new_delivery_date !== undefined && data.new_delivery_date !== null) {
                this.new_delivery_date = new Date(data.new_delivery_date);
            }
            this.created_at = null;
            if (data.createdAt !== undefined && data.createdAt !== null) {
                this.created_at = new Date(data.createdAt);
            }
            if (data.strongoShipmentParcel !== undefined && data.strongoShipmentParcel !== null) {
                this.strongoShipmentParcel = new StrongoShipmentParcel(data.strongoShipmentParcel);
            } else {
                this.strongoShipmentParcel = null;
            }
        }
    }
}

export type StrongoShipmentParcelDeliveryDateChangeData = {
    id: number;
    previous_delivery_date?: Date | null | undefined;
    new_delivery_date?: Date | null | undefined;
    createdAt?: Date | null | undefined;
    strongoShipmentParcel?: StrongoShipmentParcelData | null | undefined;
}
